import React from "react";
import { Check } from "lucide-react";
import { media, translations } from "../mock";
import { useLang } from "../i18n/LanguageContext";
import useReveal from "../hooks/useReveal";

export default function LocalNetwork() {
  const { ref, visible } = useReveal();
  const { lang } = useLang();
  const n = translations[lang].localNetwork;

  return (
    <section className="py-24 md:py-28">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div ref={ref} className={`grid lg:grid-cols-2 gap-14 items-center reveal ${visible ? "is-visible" : ""}`}>
          <div className="relative rounded-[2rem] overflow-hidden device-shadow">
            <img src={media.localNetworkImage} alt="Modern hospital in Qatar" className="w-full h-[380px] md:h-[460px] object-cover" />
          </div>
          <div>
            <span className="text-sm font-bold uppercase tracking-widest text-cblue">{n.eyebrow}</span>
            <h2 className="mt-3 font-display text-3xl md:text-4xl font-extrabold text-navy leading-tight">{n.title}</h2>
            <p className="mt-5 text-slate-600 leading-relaxed max-w-xl">{n.subtitle}</p>
            <ul className="mt-8 space-y-4">
              {n.points.map((p, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-emerald-100"><Check className="h-4 w-4 text-emerald-600" strokeWidth={3} /></span>
                  <span className="text-navy font-medium">{p}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
